import { Project } from '../api/types'

/**
 * True when the project has Unifier integration configured (API or raw DB fields).
 * Mirrors backend `project_has_unifier_integration` plus defensive checks if only
 * raw fields are present on `projectData`.
 */
export function projectHasUnifierIntegration(
  projectData: Partial<Project> | Record<string, unknown> | null | undefined,
): boolean {
  if (!projectData || typeof projectData !== 'object') return false
  const p = projectData as Partial<Project> & Record<string, unknown>
  if (p.has_unifier_integration === true) return true
  const s = (v: unknown) =>
    typeof v === 'string' && v.trim().length > 0 ? v.trim() : ''
  return Boolean(
    s(p.unifier_base_url) ||
      s(p.unifier_tenant_id) ||
      s(p.unifier_project_number),
  )
}
